/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { TaskList, ITaskListOwnProps, ITaskListStateProps, ITaskListDispatchProps } from "../../components/task/taskList";
import { Base } from "ui/Scripts/source/framework/base";

export function mapStateToProps(applicationState: IApplicationState, ownProps: ITaskListOwnProps): ITaskListStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.task) || Base.isNullOrUndefined(applicationState.task.taskList)) {
        return {
            user: null,
            hasMore: true,
            isLoading: false,
            page: 0,
            items: [],
            stateId: null,
            taskStates: [],
            unitId: null,
            units: [],
            sortColumn: "",
            lastOpenedTaskId: "",
            canCreateTasks: false
        };
    }
    const taskList = applicationState.task.taskList;
    return {
        user: applicationState.user,
        hasMore: taskList.hasMore,
        isLoading: taskList.isLoading,
        page: taskList.page,
        items: taskList.items,
        stateId: taskList.stateId,
        taskStates: taskList.taskStates,
        unitId: taskList.unitId,
        units: taskList.units,
        sortColumn: taskList.sortColumn,
        lastOpenedTaskId: taskList.lastOpenedTaskId,
        canCreateTasks: taskList.canCreateTasks
    };
}

export function mapDispatchToProps(dispatch: storeEffects.TaskThunkDispatch): ITaskListDispatchProps {
    return {
        loadTasks: (page: number, stateId: string, unitId: string) => dispatch(storeEffects.getTaskList(page, stateId, unitId)),
        removeTask: (id: string) => dispatch(storeActions.taskListRemove(id)),
        resetTasks: () => dispatch(storeActions.taskListReset()),
        refreshTasks: (page: number, stateId: string, unitId: string) => dispatch(storeEffects.taskListRefresh(page, stateId, unitId)),
        setLastOpenedTaskId: (id: string) => dispatch(storeActions.taskListSetLastOpened(id)),
        setReturnUrl: (url: string) => dispatch(storeActions.taskEditSetReturnUrl(url)),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<ITaskListStateProps, ITaskListDispatchProps, ITaskListOwnProps>(mapStateToProps, mapDispatchToProps)(TaskList);